import Clazz from '../common/Clazz';

/**
 * 地图符号基类,所有符号均从此类派生.
 */
export default class Symbol extends Clazz {
    constructor(options) {
        super();

        this.name = null;

        this._resourceFactory = null;
    }

    /**
     * 从json中读取符号属性.
     * @param {object} json - 符号属性json对象
     * @return {undefined}
     */
    fromJson(json) {
        this._setValue('name', json.name);
    }

    /**
     * 将符号属性导出为json对象.
     * @returns {object} 符号属性的json表达
     */
    toJson() {
        return {
            name: this.name,
            type: this.constructor.name
        };
    }

    /**
     * 如果符号对象拥有对应名称的属性,则将值赋值给符号对象
     * 注意：这是个内部函数，不是公共接口
     * @param {String} propName - 符号属性
     * @param {*} value         - 符号属性对应的值
     * @returns {undefined}
     */
    _setValue(propName, value) {
        if (!this.hasOwnProperty(propName)) {
            return;
        }

        // 允许0值
        if (value === undefined || value === null) {
            return;
        }

        this[propName] = value;
    }

    /**
     * 获取符号依赖的图片的url，以便在外部提前进行加载后生成对应image对象
     */
    getImgUrls() {
        const urls = [];
        if (this.url) {
            urls.push(this.url);
        }

        // 带marker的符号
        if (this.marker) {
            urls.push(...this.marker.getImgUrls());
        }

        // 组合符号
        if (this.symbols) {
            this.symbols.forEach(symbol => {
                urls.push(...symbol.getImgUrls());
            });
        }

        return urls;
    }

    /**
     * 设置资源管理器，用于根据图片的url获取对应的image对象
     * @param {object} factory 
     */
    setResourceFactory(factory) {
        this._resourceFactory = factory;

        // 带marker的符号
        if (this.marker) {
            this.marker.setResourceFactory(factory);
        }

        // 组合符号
        if (this.symbols) {
            this.symbols.forEach(symbol => {
                symbol.setResourceFactory(factory);
            });
        }
    }

    /**
     * 在设备上下文中绘制符号,未实现,需要在子类中重写.
     * @param {object} ctx - 设备上下文,通过canvas.getContext('2d')方法获得.
     * @param {object} geometry - 要绘制的几何
     * @return {undefined}
     */
    draw(ctx, geometry) {}

    /**
     * 绘制LineString对象,只负责绘制坐标
     * 因为使用频繁，所以封装到基类.
     * @param {object} ctx - 设备上下文
     * @param {Object} geometry - LineString对象
     * @returns {undefined}
     */
    _drawLineString(ctx, geometry) {
        if (geometry.coordinates.length > 0) {
            ctx.moveTo(geometry.coordinates[0].x, geometry.coordinates[0].y);
            for (let i = 1; i < geometry.coordinates.length; ++i) {
                ctx.lineTo(geometry.coordinates[i].x, geometry.coordinates[i].y);
            }
        }
    }
}
